import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { PillarGoals } from './PillarGoals'
import { useWellbeingGoals } from 'hooks/useWellbeingGoals'

import { activateOnboardingStep, setOnboardingAnswers } from 'actions/assessment'
import './style.scss'
import { postAnalytics } from 'actions/analytics'

const Goal = () => {
    const dispatch = useDispatch()

    const {
        appState: {
            onboardingAnswers: { pillarSelected, goalTag },
        },
    } = useSelector(state => state.assessment)
    const { getGoalTagsList, pillarsGoals } = useWellbeingGoals()
    const [goal, setGoal] = useState('')

    useEffect(() => {
        getGoalTagsList()
    }, [])

    useEffect(() => {
        if (goalTag) {
            dispatch(activateOnboardingStep({ number: 6, state: false }))
        }
    }, [goalTag])

    useEffect(() => {
        if (goal) {
            dispatch(activateOnboardingStep({ number: 6, state: false }))
            dispatch(setOnboardingAnswers(goal, 'goalTag'))
        }
    }, [goal])

    const handleGoal = ans => {
        dispatch(postAnalytics('[PillarGoals] onPress', `Answer ${pillarSelected} ${ans.tag} true`))
        setGoal(ans.tag)
    }
    return <PillarGoals pillarSelected={pillarSelected} goals={pillarsGoals} goalTag={goalTag} goalSelected={goal} onSelectGoal={handleGoal} />
}

export default Goal
